module.exports = __webpack_public_path__ + "static/media/mcash-main.a0ca15c2.svg";